import { Spinner } from '@cian/ui-kit';
import { Typography } from '../Typography';
import * as React from 'react';
import * as styles from './styles.css';

export const LoadingBlock = () => {
  return (
    <div className={styles['container']}>
      <Spinner size={32} colorType="inherit" />
      <Typography.Title level={6}>Загружаем лучшие вакансии...</Typography.Title>
    </div>
  );
};
